<app-spinner name="role-request-overview"></app-spinner>

<div>
  @if (false) {
    <app-alert></app-alert>
  }

  <app-multi-org-filter [showRequired]="true" (selectedOrgChange)="onOrgChange()"></app-multi-org-filter>

  <div class="mtb-20">
    <h3>Role Overview</h3>
  </div>

  <!-- Current Roles Section -->
  <div class="mb-30">
    <div class="card fluid">
      <div class="card__content border-bottom border-gray-600">
        <div class="width-full">
          <div class="mtb-10">
            <b>Current Roles</b>
          </div>
          @if (userRoles?.length) {
            <ul class="roles">
              @for (role of userRoles; track role) {
                <li>{{ role.roleName }}</li>
              }
            </ul>
          }
          @if (!userRoles?.length) {
            <div class="flex justify-center mt-20">
              <div class="mtb-20">
                <b>No roles found</b>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Pending Role Requests Section -->
  <div class="mb-30">
    <div class="card fluid mb-30">
      <div class="card__content border-bottom border-gray-600">
        <div class="width-full">
          <div class="mtb-10">
            <b>Role Requests Pending Approval</b>
          </div>

          <!-- Desktop View -->
          <div class="mt-10 desktop-view">
            <div class="overflow-auto">
              <table class="table-ode">
                <thead>
                  <tr>
                    <th>Role Name</th>
                    <th>Org Name</th>
                    <th>Request Type</th>
                    <th>Approval Status</th>
                    <th>Approved By</th>
                    <th>Approved Date</th>
                  </tr>
                </thead>
                <tbody>
                  @for (roleRequest of roleRequestsData.currentData; track roleRequest) {
                    <tr>
                      <td>{{ roleRequest.roleName }}</td>
                      <td>{{roleRequest.orgName}} ({{roleRequest.orgIrn}})</td>
                      <td>{{ roleRequest.roleRequestType}}</td>
                      <td>{{ addSpacesAtCapitals(roleRequest.workflowStateName) }}</td>
                      <td></td> <!-- Approved By (if needed) -->
                      <td></td> <!-- Approved Date (if needed) -->
                    </tr>
                  }
                  @if (!roleRequestsData?.currentData?.length) {
                    <tr>
                      <td colspan="5" class="text-center bold">No role requests found</td>
                    </tr>
                  }
                </tbody>
              </table>
              @if (roleRequestsData?.currentData?.length > 0) {
                <div class="row">
                  <div class="paginator-adjust">
                    <eas-ui-lib-paginator [currentPage]="roleRequestsData.currentPage" [pageSize]="roleRequestsData.pageSize" [totalSize]="roleRequestsData.roleRequests.length"
                    (pageChanged)="OnRoleRequestPageChanged($event)"></eas-ui-lib-paginator>
                  </div>
                </div>
              }
            </div>
          </div>

          <!-- Mobile View -->
          <div class="mt-10 mobile-view">
            @for (roleRequest of roleRequestsData.roleRequests; track roleRequest) {
              <ul class="info pb-10 mb-20">
                <li>
                  <div>Role Name</div>
                  <div class="bold">{{ roleRequest.roleKey }}</div>
                </li>
                <li>
                  <div>Org Name</div>
                  <div class="bold">{{roleRequest.orgName}} ({{roleRequest.orgIrn}})</div>
                </li>
                <li>
                  <div>Request Type</div>
                  <div class="bold">{{ roleRequest.roleRequestType }}</div>
                </li>
                <li>
                  <div>Approval Status</div>
                  <div class="bold">{{ roleRequest.workflowStateKey }}</div>
                </li>
                <li>
                  <div>Approved By</div>
                  <div class="bold">{{ roleRequest.updatePersonKey }}</div>
                </li>
                <li>
                  <div>Approved Date</div>
                  <div class="bold">{{ roleRequest.updateTs | date: 'MM/dd/yyyy hh:mm a'}}</div>
                </li>
              </ul>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Role History Section -->
  <div class="mb-30">
    <div class="card fluid mb-30">
      <div class="card__content border-bottom border-gray-600">
        <div class="width-full">
          <div class="mtb-10">
            <b>Role Request History</b>
          </div>

          <!-- Desktop View -->
          <div class="mt-10 desktop-view">
            <div class="overflow-auto">
              <table class="table-ode">
                <thead>
                  <tr>
                    <th>Role Name</th>
                    <th>Org Name</th>
                    <th>Request Type</th>
                    <th>Role Change Status</th>
                    <th>Changed By</th>
                    <th>Change Date</th>
                  </tr>
                </thead>
                <tbody>
                  @for (roleRequest of roleHistoryData.currentData; track roleRequest) {
                    <tr>
                      <td>{{ roleRequest.roleName }}</td>
                      <td>{{roleRequest.orgName}} ({{roleRequest.orgIrn}})</td>
                      <td>{{ roleRequest.roleRequestType}}</td>
                      <td>{{ addSpacesAtCapitals(roleRequest.workflowStateName) }}</td>
                      <td>{{ roleRequest.updatedBy }}</td>
                      <td>{{ roleRequest.updateTs | date: 'MM/dd/yyyy hh:mm a' }}</td>
                    </tr>
                  }
                  @if (!roleHistoryData?.currentData?.length) {
                    <tr>
                      <td colspan="5" class="text-center"><strong>No role history found</strong></td>
                    </tr>
                  }
                </tbody>
              </table>
              @if (roleHistoryData?.currentData?.length > 0) {
                <div class="row">
                  <div class="paginator-adjust">
                    <eas-ui-lib-paginator [currentPage]="roleHistoryData.currentPage" [pageSize]="roleHistoryData.pageSize" [totalSize]="roleHistoryData.roleRequestsHistory.length"
                    (pageChanged)="onHisoryPageChanged($event)"></eas-ui-lib-paginator>
                  </div>
                </div>
              }
            </div>
          </div>

          <!-- Mobile View -->
          <div class="mt-10 mobile-view">
            @for (roleRequest of roleHistoryData.roleRequestsHistory; track roleRequest) {
              <ul class="info pb-10 mb-20">
                <li>
                  <div>Role Name</div>
                  <div class="bold">{{ roleRequest.roleKey }}</div>
                </li>
                <li>
                  <div>Org Name</div>
                  <div class="bold">{{roleRequest.orgName}} ({{roleRequest.orgIrn}})</div>
                </li>
                <li>
                  <div>Request Type</div>
                  <div class="bold">{{ roleRequest.roleRequestType }}</div>
                </li>
                <li>
                  <div>Approval Status</div>
                  <div class="bold">{{ roleRequest.workflowStateKey }}</div>
                </li>
                <li>
                  <div>Approved By</div>
                  <div class="bold">{{ roleRequest.updatePersonKey }}</div>
                </li>
                <li>
                  <div>Approved Date</div>
                  <div class="bold">{{ roleRequest.updateTs | date: 'MM/dd/yyyy hh:mm a'}}</div>
                </li>
              </ul>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Back Button Section -->
  <div class="container flex border-top border-gray-600 mt-20 pt-10">
    <span class="basis-50">
      <span class="flex justify-start">
        <button [routerLink]="['../']" class="secondary border-red rounded-4 hover-red hover-font-white flex-row-reverse mobile">
          <div class="btn-txt font-red bold">Back</div>
        </button>
      </span>
    </span>
    <span class="basis-50"></span>
  </div>
</div>
